import { render, staticRenderFns } from "./MessageInput.vue?vue&type=template&id=53dcd9fe&scoped=true&"
import script from "./MessageInput.vue?vue&type=script&lang=ts&"
export * from "./MessageInput.vue?vue&type=script&lang=ts&"
import style0 from "./MessageInput.vue?vue&type=style&index=0&id=53dcd9fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dcd9fe",
  null
  
)

export default component.exports